module.exports = __webpack_public_path__ + "static/media/logo-text.d4f7b32b.svg";